import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import "./style.css";
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  Button,
  Label,
  Input,
  ToolbarButton,
  MessageBar,
  MessageBarActions,
  MessageBarTitle,
  MessageBarBody,
  MessageBarGroup,
} from "@fluentui/react-components";
import { Dismiss16Regular } from "@fluentui/react-icons";
import ReactQuill from "react-quill";
import { MasterDataTable } from "../MasterDataTable";
import ContactHistortForm from "../../pages/client/ContactHistory/ContactHistortForm";
import ActionListForm from "../../pages/Actionlist/ActionListForm";
import apiServices from "../../service";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import Provider from "../../pages/client/Provider/Provider";
import LoadStandardAction from "../LoadStandardAction";
import ActionListDateFilter from "../../pages/Actionlist/ActionListDateFilter";
import { PageLoader } from "../Loader/PageLoader";
import DistributionRule from "../../pages/Commission/DistributionRule/Rule";
import ASCButton from "../Button";
import CustomerSelection from "../CustomerSelection";

export const ModalDialog = (props: any) => {
  const [isDelete, setIsDelete] = useState<boolean>(true);
  const [inputValue, setInputValue] = useState("");
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [bulkData, setBulkData] = useState<any>({});
  const [inputErrorMsg, setInputErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isContentLoading, setIsContentLoading] = useState<boolean>(false);
  // const [pageLoading, setPageLoading] = useState<boolean>(
  //   props.options.loader !== undefined ? props.options?.loader : false
  // );
  useEffect(() => {
    if (props.options?.table_type === "objectives") {
      setBulkData({
        Objective: {
          customer_id: props.options?.customerId,
          objectives: checkedItems,
        },
      });
    } else if (props.options?.table_type === "income") {
      setBulkData({
        income: {
          customer_id: props.options?.customerId,
          income_categories: checkedItems,
        },
      });
    } else if (props.options?.table_type === "outgoings") {
      setBulkData({
        outgoings: {
          customer_id: props.options?.customerId,
          expense_categories: checkedItems,
        },
      });
    } else if (props.options?.table_type === "attitudeToRisk") {
      let hasEmptyRating = checkedItems.some(
        (item: any) => item.rating_id === ""
      );
      if (hasEmptyRating) {
        setInputErrorMsg("All items must have a rating_id");
      } else {
        setBulkData({
          attitude_to_risk: {
            customer_id: props.options?.customerId,
            attitude_risks: checkedItems,
          },
        });
        setInputErrorMsg("");
      }
    }
  }, [checkedItems]);

  function onDelete(e: React.ChangeEvent<HTMLInputElement>) {
    setInputValue(e.target.value);
    const string = e.target.value.toLowerCase();
    if (string === "yes") setIsDelete(false);
    else setIsDelete(true);
  }

  const onApply = (callback: any) => {
    setIsContentLoading(true);
    if (props.options?.table_type === "objectives") {
      if (
        bulkData.Objective &&
        Array.isArray(bulkData.Objective.objectives) &&
        bulkData.Objective.objectives.length > 0
      ) {
        apiServices.getDefaultobjective
          .add(bulkData)
          .then(() => {
            setCheckedItems([]);
            setIsContentLoading(false);
            callback();
            props.options?.reload();
          })
          .catch((e: Error) => {
            console.log(e);
            setIsContentLoading(false);
          });
      }
    } else if (props.options?.table_type === "income") {
      if (
        bulkData.income &&
        Array.isArray(bulkData.income.income_categories) &&
        bulkData.income.income_categories.length > 0
      ) {
        apiServices.getDefaultIncome
          .add(bulkData)
          .then(() => {
            setCheckedItems([]);
            setIsContentLoading(false);
            callback();
            props.options?.reload();
          })
          .catch((e: Error) => {
            console.log(e);
            setIsContentLoading(false);
          });
      }
    } else if (props.options?.table_type === "outgoings") {
      if (
        bulkData.outgoings &&
        Array.isArray(bulkData.outgoings.expense_categories) &&
        bulkData.outgoings.expense_categories.length > 0
      ) {
        apiServices.getDefaultexpense
          .add(bulkData)
          .then(() => {
            setCheckedItems([]);
            setIsContentLoading(false);
            callback();
            props.options?.reload();
          })
          .catch((e: Error) => {
            console.log(e);
            setIsContentLoading(false);
          });
      }
    } else if (props.options?.table_type === "attitudeToRisk") {
      if (
        bulkData.attitude_to_risk &&
        Array.isArray(bulkData.attitude_to_risk.attitude_risks) &&
        bulkData.attitude_to_risk.attitude_risks.length > 0
      ) {
        let hasEmptyRating = bulkData.attitude_to_risk.attitude_risks.some(
          (item: any) => item.rating_id === ""
        );

        if (hasEmptyRating) {
          setInputErrorMsg(
            "One or more 'rating' values are empty. Please fill all ratings."
          );
        } else {
          apiServices.getDefaultAttitudeToRisk
            .add(bulkData)
            .then(() => {
              setCheckedItems([]);
              setInputErrorMsg("");
              setIsContentLoading(false);
              callback();
              props.options?.reload();
            })
            .catch((e: Error) => {
              console.log(e);
              setIsContentLoading(false);
            });
        }
      }
      // if (
      //   bulkData.attitude_to_risk &&
      //   bulkData.attitude_to_risk.attitude_risks.length !== 0
      // ) {
      //   apiServices.getDefaultAttitudeToRisk.add(bulkData).then(() => {
      //     setCheckedItems([]);
      //     setInputErrorMsg("");
      //     props.options?.reload();
      //   });
      // }
    }
  };
  return (
    <Dialog open={props.options?.open}>
      <DialogSurface
        aria-modal="false"
        style={{
          minHeight: props.options?.date_filter && "35dvh",
          maxWidth: props.options?.rule && "80vw",
        }}
      >
        <DialogBody>
          {/* {props.options && props.options?.close && (
          <ToolbarButton
            aria-label="Close panel"
            appearance="subtle"
            icon={<Dismiss16Regular />}
            onClick={props.options?.close.onclick()}
          />
        )} */}
          <DialogTitle
          // action={
          //   <DialogTrigger action="close">
          //     <Button
          //       appearance="subtle"
          //       aria-label="close"
          //       icon={
          //         <Dismiss16Regular
          //           onClick={() => props.options?.close.onclick()}
          //         />
          //       }
          //     />
          //   </DialogTrigger>
          // }
          >
            {props.options?.title}
            {/* {props.options && props.options?.close && (
              <div className="close-button-end-parent">
                <Dismiss16Regular
                  className="close-button-end"
                  onClick={() => props.options?.close.onclick()}
                />
              </div>
            )} */}
          </DialogTitle>
          <DialogContent>
            {inputErrorMsg !== "" && (
              <div>
                <MessageBar key="1" intent="error">
                  <MessageBarBody>
                    <MessageBarTitle>{inputErrorMsg}</MessageBarTitle>
                  </MessageBarBody>
                  <MessageBarActions
                    containerAction={
                      <ASCButton
                        shape="rounded"
                        onClick={() => setInputErrorMsg("")}
                        aria-label="dismiss"
                        appearance="transparent"
                        icon={<Dismiss16Regular />}
                      />
                    }
                  />
                </MessageBar>
              </div>
            )}

            {props.options?.content_line_1 && (
              <div>
                <Label size="large" weight="semibold">
                  {props.options?.content_line_1}
                </Label>
              </div>
            )}

            {props.options?.showMore_text && (
              <ReactQuill
                value={DOMPurify.sanitize(props.options?.showMore_text)}
                readOnly={true}
                theme={"bubble"}
              />
            )}

            {props.options?.client_table && (
              <CustomerSelection
                customerSelection={props.options?.customerSelection}
              />
            )}

            {props.options?.date_filter && (
              <ActionListDateFilter
                dateSelection={props.options?.dateSelection}
                dateLabel={props.options?.dateLabel}
                optionDateValue={props.options?.optionDateValue}
                optionDate={props.options?.optionDate}
              />
            )}

            {props.options?.contact_history_data && (
              <ContactHistortForm
                data={props.options?.contact_history_data}
                customerId={props.options?.customerId}
                type={props.options?.type}
                setActiveItem={props.options?.setActiveItem}
                activeClient={props.options?.activeClient}
                case_type={
                  props.options?.case_type ? props.options?.case_type : ""
                }
              />
            )}
            {props.options?.load_action && (
              <LoadStandardAction
                updateSelectedActions={
                  props.options?.updateSelectedActions
                    ? props.options?.updateSelectedActions
                    : undefined
                }
                type={props.options?.load_action_type}
              />
            )}
            {props.options?.rule && (
              <DistributionRule
                ruleId={props.options?.ruleId}
                options={props.options}
              />
            )}
            {props.options?.provider && (
              <Provider
                providerId={props.options?.providerId}
                options={props.options}
                selectedProvider={props.selectedProvider}
              />
            )}

            {props.options?.action_list_data && (
              <ActionListForm
                data={props.options?.action_list_data}
                cancelPopup={props.options?.cancel.onclick}
                getActionListData={props.getActionListData}
              />
            )}

            {props.options?.master_table && (
              <MasterDataTable
                setCheckedItems={setCheckedItems}
                checkedItems={checkedItems}
                type={props.options?.table_type}
              />
            )}

            {props.options?.content_line_2 && (
              <div>
                <Label size="medium" weight="regular">
                  {props.options?.content_line_2}
                </Label>
              </div>
            )}
            {props.options?.content_line_3 && (
              <div>
                <Label size="medium" weight="regular">
                  {props.options?.content_line_3}
                </Label>
              </div>
            )}
            {props.options?.deleteInput && (
              <div>
                <Input size="medium" value={inputValue} onChange={onDelete} />
              </div>
            )}
          </DialogContent>
          {!props.options?.action_list_data && (
            <DialogActions>
              {props.options && props.options?.deleteInput && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    className="asc-button-primary"
                    appearance="primary"
                    onClick={() => {
                      props.options?.deleteInput.onclickYes();
                      setInputValue("");
                      setIsDelete(true);
                    }}
                    disabled={isDelete}
                    label={props.options?.deleteInput.labelYes}
                  />
                </DialogTrigger>
              )}

              {props.options && props.options?.deleteInput && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    appearance="secondary"
                    onClick={() => {
                      props.options?.deleteInput.onclickNo();
                      setInputValue("");
                      setIsDelete(true);
                    }}
                    label={props.options?.deleteInput.labelNo}
                  />
                </DialogTrigger>
              )}

              {props.options && props.options?.yes && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    className={`${
                      props.options?.yes.type === "primary"
                        ? "asc-button-primary"
                        : ""
                    }`}
                    appearance={
                      props.options?.yes.type === "primary"
                        ? "primary"
                        : "secondary"
                    }
                    onClick={() => {
                      props.options?.yes.onclick();
                    }}
                    label={props.options?.yes.label}
                  />
                </DialogTrigger>
              )}

              {props.options && props.options?.apply && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    size="medium"
                    className={`${
                      props.options?.apply.type === "primary"
                        ? "asc-button-primary"
                        : ""
                    }`}
                    appearance={
                      props.options?.apply.type === "primary"
                        ? "primary"
                        : "secondary"
                    }
                    onClick={() => {
                      onApply(() => {
                        props.options?.apply.onclick();
                      });
                    }}
                    label={props.options?.apply.label}
                  />
                </DialogTrigger>
              )}
              {props.options && props.options?.select && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    size="medium"
                    className={`${
                      props.options?.select.type === "primary"
                        ? "asc-button-primary"
                        : ""
                    }`}
                    appearance={
                      props.options?.select.type === "primary"
                        ? "primary"
                        : "secondary"
                    }
                    onClick={() => {
                      onApply(() => {
                        props.options?.select.onclick();
                      });
                    }}
                    label={props.options?.select.label}
                  />
                </DialogTrigger>
              )}

              {props.options && props.options?.no && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    size="medium"
                    className={`${
                      props.options?.no.type === "primary"
                        ? "asc-button-primary"
                        : ""
                    }`}
                    appearance={
                      props.options?.no.type === "primary"
                        ? "primary"
                        : "secondary"
                    }
                    onClick={() => {
                      props.options?.no.onclick();
                    }}
                    label={props.options?.no.label}
                  />
                </DialogTrigger>
              )}
              {props.options && props.options?.cancel && (
                <DialogTrigger disableButtonEnhancement>
                  <ASCButton
                    shape="rounded"
                    size="medium"
                    className={`${
                      props.options?.cancel.type === "primary"
                        ? "asc-button-primary"
                        : ""
                    }`}
                    appearance={
                      props.options?.cancel.type === "primary"
                        ? "primary"
                        : "secondary"
                    }
                    onClick={() => {
                      props.options?.cancel.onclick();
                      setCheckedItems([]);
                    }}
                    label={props.options?.cancel.label}
                  />
                </DialogTrigger>
              )}
            </DialogActions>
          )}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
export default ModalDialog;
